import {withTableCell} from './withTableCell';
import {TableCellStyle} from './TableCellStyle';

/**
 * Represents a cell within a table.
 * Will render `th` element if it is a child of a `thead`, otherwise will render as `td` element.
 *
 * @component
 */
export const TableCell = withTableCell(TableCellStyle);
